import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/context/AuthContext";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri"];
const PERIODS = [1, 2, 3, 4, 5, 6];

export default function TimetablePage() {
  const { user } = useAuth();
  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState("");
  const [slots, setSlots] = useState([]);

  useEffect(() => {
    api.get("/classes").then((r) => {
      setClasses(r.data);
      const preset = user?.class_id || r.data[0]?.id;
      if (preset) setClassId(preset);
    });
  }, [user]);

  useEffect(() => {
    if (!classId) return;
    api.get("/timetable", { params: { class_id: classId } }).then((r) => setSlots(r.data));
  }, [classId]);

  const grid = {};
  slots.forEach((s) => {
    grid[`${s.day}-${s.period}`] = s;
  });

  return (
    <div className="space-y-6" data-testid="timetable-page">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground">Schedule</div>
          <h1 className="text-4xl font-bold tracking-tight">Timetable</h1>
          <p className="text-muted-foreground text-sm mt-1">6-period day, Mon–Fri.</p>
        </div>
        <Select value={classId} onValueChange={setClassId}>
          <SelectTrigger className="w-48 rounded-2xl" data-testid="tt-class-select"><SelectValue placeholder="Class" /></SelectTrigger>
          <SelectContent>{classes.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
        </Select>
      </div>

      <Card className="rounded-2xl overflow-hidden">
        <CardHeader><CardTitle className="text-base">Weekly view</CardTitle></CardHeader>
        <CardContent>
          <div className="grid grid-cols-6 gap-2 text-sm">
            <div className="text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground"></div>
            {DAYS.map((d) => (
              <div key={d} className="text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground text-center">{d}</div>
            ))}
            {PERIODS.map((p) => (
              <React.Fragment key={p}>
                <div className="text-[0.65rem] tracking-[0.2em] uppercase text-muted-foreground pt-3">P{p}</div>
                {DAYS.map((d) => {
                  const s = grid[`${d}-${p}`];
                  return (
                    <div
                      key={`${d}-${p}`}
                      className="p-3 rounded-xl bg-muted/40 min-h-[68px] flex flex-col justify-between"
                      data-testid={`slot-${d}-${p}`}
                    >
                      {s ? (
                        <>
                          <div className="text-sm font-medium">{s.subject}</div>
                          <Badge variant="outline" className="rounded-full self-start text-[0.65rem]">P{p}</Badge>
                        </>
                      ) : (
                        <div className="text-xs text-muted-foreground">—</div>
                      )}
                    </div>
                  );
                })}
              </React.Fragment>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
